import moment from "moment-timezone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { osVersion, browserVersion, osName, isIOS, isSafari, isChrome, isEdge } from "react-device-detect";
import { roundToNearestMinutes, setMinutes } from "date-fns";
import { ROUTES } from "@amplio-common/constants";
import { Trans } from "@lingui/macro";

export const getLoginToken = () => {
  let credType = "JWT";
  if (localStorage.getItem("code_login_token")) { credType = "CODE"; }
  if (localStorage.getItem("class_login_token")) { credType = "CLASS"; }
  //const credType = localStorage.getItem("totp_token") || localStorage.getItem("access_token") ?  : "CODE";
  
  const credToken = localStorage.getItem("totp_token") || localStorage.getItem("access_token") || localStorage.getItem("code_login_token") || localStorage.getItem("class_login_token");
  return `${credType} ${credToken}`;
};

export const itemDictToSelectOptions = (itemDict) => Object.values(itemDict).map(item => ({ value: item.id, label: item.name }));
export const itemArrayToSelectOptions = (itemArray) => itemArray.map(item => ({ value: item?.id, label: item?.name }));
export const itemDictTitleToSelectOptions = (itemDict) => Object.values(itemDict).map(item => ({ value: item.id, label: item.title }));
export const sortLabelByLexOrder = (a, b) => (a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1);
export const sortValueByLexOrder = (a, b) => (a.value > b.value ? 1 : -1);
export const sortUsersByLexOrder = (a, b) => ((a.first_name + a.last_name).toLowerCase() > (b.first_name + b.last_name).toLowerCase() ? 1 : -1);
export const sortUsersByName = (a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
export const sortClinicsByLexOrder = (a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
export const sortByName = (a, b) => (a.name.toLowerCase() >= b.name.toLowerCase() ? 1 : -1);
export const sortByStudentName = (a, b) => (a.student.name.toLowerCase() >= b.student.name.toLowerCase() ? 1 : -1);
export const replaceAll = (baseString, txtToReplace, newTxt) => baseString.split(txtToReplace).join(newTxt);
export const idArrayToDict = (arr) => arr.reduce((res, acc) => { res[acc.id] = acc; return res; }, {});
export const studenIdArrayToDict = (arr) => arr.reduce((res, acc) => { res[acc.student_id] = acc; return res; }, {});

export const filterItemDictToSelectOptions = (itemDict, conditionParam) => Object.values(itemDict).reduce((acc, item) => {
  if (item?.[conditionParam]) {
    const { id, name } = item;
    acc.push({ value: id, label: name, name });
  }
  return acc;
}, []);




export const convertToNearest15Minutes = time => {
  time.setSeconds(0);
  const newTime = roundToNearestMinutes(time, { nearestTo: 15 });
  return newTime >= time ? newTime : setMinutes(newTime, newTime.getMinutes() + 15);
};


export const setUniqueServicesFromMultipleTherapists = (state) => {
  const services = [];
  state.studentTherapists.forEach(slp => {
    services.push(...slp.services);
  });
  const uniqueServices = services.filter((value, index, self) =>
    index === self.findIndex((t) => (
      t.id === value.id && t.name === value.name
    )));
  state.serviceOptions = itemArrayToSelectOptions(uniqueServices);
  state.serviceId = uniqueServices[0].id;
};

export const deepCopy = (obj) => {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  if (obj instanceof Date) {
    return new Date(obj.getTime());
  }

  if (obj instanceof Array) {
    return obj.reduce((arr, item, i) => {
      arr[i] = deepCopy(item);
      return arr;
    }, []);
  }

  if (obj instanceof Object) {
    return Object.keys(obj).reduce((newObj, key) => {
      newObj[key] = deepCopy(obj[key]);
      return newObj;
    }, {});
  }
};

export const cleanObjFromNull = (obj) => Object.entries(obj).reduce((a, [k, v]) => (v === null ? a : {
  ...a,
  [k]: v,
}), {});

export const getFormattedDate = (date, format = "DD-MMM-YY", defaultText = <Trans>Invalid Date</Trans>) => (moment(date).isValid() ? moment(date).format(format) : defaultText);
export const getFormattedDateTZ = (date, tz, format = "DD-MMM-YY", defaultText = "Invalid Date") => (moment.tz(date, tz).isValid() ? moment.tz(date, tz).format(format) : defaultText);
export const getFormattedDateTime = (dt) => getFormattedDate(dt, "DD-MMM-YY HH:mm");
export const getFormattedDateTimeTZ = (dt, tz) => getFormattedDateTZ(dt, tz, "DD-MMM-YY hh:mm");
export const getFormattedTimeTZ = (dt, tz) => getFormattedDateTZ(dt, tz, "HH:mm");
moment.locale("he");
export const getFormattedDateTZV4 = (date, tz, format = "ddd, MMM Do YYYY", defaultText = "Invalid Date") => (moment.tz(date, tz).isValid() ? moment.tz(date, tz).format(format) : defaultText);


export const filterActiveUsersByStr = (str) => (user) => {
  const strLower = str.toLowerCase();
  return user.is_active === 1
    && (`${user.first_name} ${user.last_name}`.toLowerCase().includes(strLower)
      || `${user.external_reference_id || ""}`.includes(strLower)
      || `${user.id || ""}`.includes(strLower)
    );
};

export const filterUsersByStr = (str) => (user) => {
  const strLower = str.toLowerCase();
  return `${user.first_name} ${user.last_name}`.toLowerCase().includes(strLower)
    || `${user.external_reference_id || ""}`.includes(strLower)
    || `${user.id || ""}`.includes(strLower);
};

export const filterUsersByStrAndId = (str) => (user) => {
  const strLower = str.toLowerCase();
  return user.name.toLowerCase().includes(strLower) || `${user.id || ""}`.includes(strLower);
};

export const getEmailLink = (email) => <a href={`mailto:${email}`} aria-label="Save" title={email} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>&nbsp;<FontAwesomeIcon icon={faEnvelope} />&nbsp;</a>;
export const getSupportEmail = () => "moked@poppins.co.il";

export const validateUserBrowsingData = () => {
  if (isIOS) {
    const version = osVersion.split(".");
    if (version[0] < 10 || ((version[0] === 10) && (version[1] < 14))) {
      return false;
    }

    if (isSafari) {
      return true;
    }
  }

  return ((isChrome || isEdge) && parseInt(browserVersion) >= 73);
};

export const actualSessionDurationRounded = (actualStart, actualEnd, errorValue = "--") => actualEnd ? Math.round(moment(actualEnd).diff(actualStart, "minutes", true)) : errorValue;
export const getIsWeakCPU = () => osName === "Chromium OS";
export const sortByFieldAlphabetically = field => (a, b) => a[field].localeCompare(b[field], undefined, { numeric: true, sensitivity: "base" });

export const formatStudentCode = (code) => {
  const studentCodeParams = code.split("-");
  const studentCode = studentCodeParams.join("");

  return [studentCode.slice(0, 2), studentCode.slice(2, 5), studentCode.slice(5)].join("-");
};

export const getViewFromURL = () => {
  const path = window.location.pathname;
  if (path.includes("/treatment/")) { return ROUTES.CLASSROOM; } // support soon-to-be legacy remote session
  if (path.includes(ROUTES.CLASSROOM)) { return ROUTES.CLASSROOM; }
  if (path.includes(ROUTES.CALENDAR)) { return ROUTES.CALENDAR; }
  if (path.includes(ROUTES.STUDENTS)) { return ROUTES.STUDENTS; }
  if (path.includes(ROUTES.TIMESHEET)) { return ROUTES.TIMESHEET; }
  if (path.includes(ROUTES.RESOURCES)) { return ROUTES.RESOURCES; }
  return null;
};

export const formatTreatreatmentCode = tCode => tCode ? tCode.match(/.{1,3}/g)?.join?.("-") || "" : "";

export const camelToSnakeCase = str => str[0].toLowerCase() + str.slice(1, str.length).replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

export const snakeToCamelCase = str => str.toLowerCase().replace(/([-_][a-z])/g, group => group.toUpperCase().replace("-", "").replace("_", ""));

export const getIsChristmasHolidays = () => {
  const nowDate = new Date();
  const month = nowDate.getMonth() + 1; // because for some reason someone thought that Jan = 0 is a good idea........
  // const day = nowDate.getDate();
  return month === 12;
};
